// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-GHt","rootMobile":"styles_rootMobile__3kMjv"};